import Loadable from 'react-loadable'
import MainLayout from '../../components/layout/MainLayout'
import LoadingPage from '../../components/layout/Loading'


const PageMain = Loadable({
  loader: () => import('../../pages/modules/List_modules'),
  loading: LoadingPage,
})

const PageAction = Loadable({
  loader: () => import('../../pages/modules/Action'),
  loading: LoadingPage,
})

const modules = [
  {
    path: '/modules',
    exact: true,
    requiredAuth: true,
    component: PageMain,
    layout: MainLayout,
  },
  {
    path: '/modules/action',
    exact: true,
    requiredAuth: true,
    component: PageAction,
    layout: MainLayout,
  },
  {
    path: '/modules/action/:id',
    exact: true,
    requiredAuth: true,
    component: PageAction,
    layout: MainLayout,
  },
]

export default modules
